import { render } from "./AdminCourses.vue?vue&type=template&id=934b8472&scoped=true"
import script from "./AdminCourses.vue?vue&type=script&lang=js"
export * from "./AdminCourses.vue?vue&type=script&lang=js"

import "./AdminCourses.vue?vue&type=style&index=0&id=934b8472&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-934b8472"]])

export default __exports__